import { StandardTabsV2 } from '@cimplico/components';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';
import { useJournals } from '../../queries/use-journals';

type JournalsTabsProps = {
    defaultIndex?: number;
    onTabChange: (index: number) => void;
};

function JournalsTabs({ defaultIndex, onTabChange }: JournalsTabsProps): JSX.Element {
    const { id } = useWorkpaperContext();
    const journalMetadataQuery = useJournals(id, { metadata: true });

    const metadata = journalMetadataQuery.data?.metadata;

    let sum = 0;
    if (metadata) {
        sum = Object.values(metadata.metadata).reduce((a, b) => a + b, 0);
    }

    return (
        <div className="border-b">
            <StandardTabsV2 name="tb-status" onChange={onTabChange} selectedIndex={defaultIndex}>
                <StandardTabsV2.Tab label={`All (${sum})`} />
                <StandardTabsV2.Tab label={`Draft (${metadata?.metadata.draft ?? 0})`} />
                <StandardTabsV2.Tab label={`Posted (${metadata?.metadata.posted ?? 0})`} />
                <StandardTabsV2.Tab label={`Voided (${metadata?.metadata.voided ?? 0})`} />
                <StandardTabsV2.Tab label={`Archived (${metadata?.metadata.archived ?? 0})`} />
            </StandardTabsV2>
        </div>
    );
}

export default JournalsTabs;
